import { createSlice } from "@reduxjs/toolkit";
import { PaymentMethodResponseDto } from "../../shared/dtos/paymentMethod/PaymentMethodResponseDto";
import {
  getInitialCrudState,
  generateCrudReducers,
} from "../utils/crudFactory";

export const paymentMethodSlice = createSlice({
  name: "paymentMethod",
  initialState: getInitialCrudState<PaymentMethodResponseDto>(),
  reducers: {
    ...generateCrudReducers<PaymentMethodResponseDto>(),
  },
});

export const paymentMethodActions = paymentMethodSlice.actions;
export default paymentMethodSlice.reducer;
